import React, { Component } from 'react';
import ProductCard from "../../customComponents/productCard/productCard";
import { Button, CircularProgress, Divider, Grid, Breadcrumbs, Typography, Link as LinkMui } from "@mui/material";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Product } from "../../../classes/types/product/product";
import { ProductHandler } from "../../../classes/methods/productMethods/productMethods";
import Pagination from "@mui/material/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import FilterPage from "../../customComponents/filterPage/filterPage";

interface props {
  page?: string;
  searchedInput: string;
  loading?: boolean;
  navigate: (path: string) => void;
}


interface state {
  loading: boolean;
  products: Product[];
  pageProducts: Product[];
  currentPage: number;
  pageNumber: number;
  numberProductsInPage: number;
  productsToView: Product[];
  isLogged: boolean;
}

class SearchPage extends Component<props, state> {
  constructor(props: props) {
    super(props);
    this.state = {
      loading: this.props.loading || false,
      products: [],
      pageProducts: [],
      productsToView: [],
      pageNumber: 1,
      currentPage: this.props.page ? Number(this.props.page) : 1,
      numberProductsInPage: 20,
      isLogged: false,
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps: Readonly<props>) {
    if (prevProps.page !== this.props.page || prevProps.searchedInput !== this.props.searchedInput) {
      this.refreshData();
    }
  }

  refreshData = () => {
    const { searchedInput, page } = this.props;

    if (searchedInput && searchedInput.length >= 3) {
      this.setState({ loading: true });

      ProductHandler.searchProducts(searchedInput)
        .then((newProducts: Product[]) => {
          const currentPage = page ? Number(page) : 1;
          const pageNumber = Math.ceil(newProducts.length / this.state.numberProductsInPage);
          const startingIndex = (currentPage - 1) * this.state.numberProductsInPage;
          const pageProducts = newProducts.slice(startingIndex, startingIndex + this.state.numberProductsInPage);

          this.setState({
            loading: false,
            products: newProducts,
            productsToView: newProducts,
            pageNumber,
            currentPage,
            pageProducts,
            isLogged: this.isLogged(newProducts),
          });
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false, currentPage: page ? Number(page) : 1, isLogged: false, products: [], productsToView: [], pageProducts: [], pageNumber: 1 });
    }
  };

  isLogged = (products: Product[]) => products.some(p => !p.configurable && p.price !== undefined);

  onProductsFiltered = (newProductsToView: Array<Product>) => {
    window.history.pushState(
      null,
      "GIGABYTE DISTRIBUZIONE",
      `/shop/cerca/${encodeURIComponent(this.props.searchedInput)}/page/1`
    );
    let productsCopy = newProductsToView.length;
    let newPageNumber = 0;
    while (productsCopy > 0) {
      productsCopy = productsCopy - this.state.numberProductsInPage;
      newPageNumber++;
    }
    let newProductsPage = new Array<Product>();
    let count = 0;
    for (let i = 0; i < newProductsToView.length; i++) {
      if (count < this.state.numberProductsInPage) {
        newProductsPage.push(newProductsToView[i]);
      } else {
        break;
      }
      count++;
    }
    this.setState({
      productsToView: newProductsToView,
      pageProducts: newProductsPage,
      pageNumber: newPageNumber,
      currentPage: 1,
    });
  }

  onPageChange = (_: React.ChangeEvent<unknown>, page: number) => {
    const startIndex = (page - 1) * this.state.numberProductsInPage;
    const pageProducts = this.state.productsToView.slice(startIndex, startIndex + this.state.numberProductsInPage);

    this.setState({ pageProducts, currentPage: page });
    this.props.navigate(
      `/shop/cerca/${encodeURIComponent(this.props.searchedInput)}/page/${page}`
    );

  };

  render() {
    const { loading, products, pageProducts, pageNumber, currentPage, isLogged } = this.state;

    return (
      // Usiamo hidden o un condizionale interno per non distruggere la FilterPage durante il caricamento
      <div style={{ wordBreak: "break-word" }}>
        <Grid container>
          {/* COLONNA SINISTRA: FILTRI */}
          <Grid xs={2} item>
            <div style={{ backgroundColor: "white", height: "40px" }}>
              <div style={{ paddingLeft: "2%", width: "fit-content", paddingTop: "1%", paddingBottom: "1%", position: "fixed", backgroundColor: "white", zIndex: 10 }}>
                <Breadcrumbs aria-label="breadcrumb">
                  <LinkMui component={Link} to="/" underline="hover" color="inherit">
                    HOME
                  </LinkMui>
                  <Typography style={{ color: 'black' }}>RICERCA</Typography>
                </Breadcrumbs>
              </div>

            </div>

            {/* Aggiungiamo un margine per non finire sotto i Breadcrumbs fixed */}
            <div style={{ marginTop: "10px" }}>
              <FilterPage
                isLogged={isLogged}
                products={products}
                loading={loading}
                onProductsFiltered={this.onProductsFiltered}
              />
            </div>
          </Grid>

          {/* COLONNA DESTRA: PRODOTTI */}
          <Grid xs={10} item>
            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20%' }}>
                <CircularProgress />
              </div>
            ) : (
              <>
                {products.length === 0 ? (
                  <div style={{ marginTop: '10%', textAlign: 'center' }}>
                    <FontAwesomeIcon style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
                    <h1>Nessun Prodotto Trovato</h1>
                    <Link to={'/'}><Button variant="contained" color="primary">Ritorna alla Pagina Iniziale</Button></Link>
                  </div>
                ) : pageProducts.length === 0 ? (
                  <div style={{ marginTop: '10%', textAlign: 'center' }}>
                    <FontAwesomeIcon style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
                    <h1>Non Esistono Prodotti Con Queste Specifiche</h1>
                  </div>
                ) : (
                  <><div style={{ paddingLeft: '2%', paddingRight: '2%', marginTop: "75px" }} className="configurable-systems">
                    <Divider variant="middle" />
                    {pageProducts.map((product, index) => (
                      <div key={index}>
                        <ProductCard
                          isLogged={isLogged}
                          linkName={`/shop/cerca/${encodeURIComponent(this.props.searchedInput)}/page/${currentPage}/prodotto/${product.id}`}
                          loading={loading}
                          product={product} />
                        <Divider variant="middle" style={{ marginBottom: '1%' }} />
                      </div>
                    ))}

                  </div><div style={{ marginLeft: "2%", width: "100%", marginTop: "2%", display: "flex", justifyContent: "center", zIndex: 10 }}>
                      <Pagination count={pageNumber} page={currentPage} color="primary" onChange={this.onPageChange} />
                    </div></>
                )}
              </>
            )}

          </Grid>

        </Grid>

      </div>
    );
  }
}

// --- Wrapper per React Router v6
export default function SearchPageWrapper() {
  const { searchedInput, page } = useParams<{ searchedInput?: string; page?: string }>();
  const decodedSearch = searchedInput ? decodeURIComponent(searchedInput) : "";
  const navigate = useNavigate();

  return (
    <SearchPage
      searchedInput={decodedSearch}
      page={page || "1"}
      navigate={navigate}
    />
  );
}